import React from "react";
import Reveal from "./Reveal";
import { WHY_US } from "../mock";

const WhyUs = () => {
  return (
    <section
      id="why-us"
      data-testid="why-us-section"
      className="bg-[#0B284A] text-[#F6F1E8] py-24 lg:py-32 relative overflow-hidden"
    >
      <div className="absolute -top-32 -right-32 w-96 h-96 rounded-full border border-[#B88A3B]/10" />
      <div className="absolute -top-16 -right-16 w-96 h-96 rounded-full border border-[#B88A3B]/10" />
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <Reveal className="max-w-2xl">
          <p className="uppercase tracking-[0.3em] text-xs font-normal text-[#B88A3B]">
            Why Choose Us
          </p>
          <h2 className="font-serif-lux font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight mt-6">
            The standard behind <span className="gold-text italic">the name</span>
          </h2>
        </Reveal>
        <div className="grid md:grid-cols-2 gap-x-16 gap-y-14 mt-20">
          {WHY_US.map((w, i) => (
            <Reveal key={w.num} delay={i * 0.08}>
              <div className="border-t border-[#B88A3B]/25 pt-8">
                <span className="font-serif-lux text-4xl text-[#B88A3B]/60">
                  {w.num}
                </span>
                <h3 className="font-serif-lux text-2xl md:text-3xl font-medium tracking-tight mt-4">
                  {w.title}
                </h3>
                <p className="text-base text-[#F9F9F7]/60 leading-relaxed mt-3 max-w-md">
                  {w.text}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
